import ar from './ar.png';
import be from './be.png';
import br from './br.png';
import co from './co.png';
import de from './de.png';
import dk from './dk.png';
import es from './es.png';
import fr from './fr.png';
import gb from './gb.png';
import gr from './gr.png';
import ie from './ie.png';
import is from './is.png';
import it from './it.png';
import lu from './lu.png';
import mt from './mt.png';
import nl from './nl.png';
import no from './no.png';
import pe from './pe.png';
import pt from './pt.png';
import se from './se.png';
import us from './us.png';
import uy from './uy.png';
import ve from './ve.png';

export default {
    ar,
    be,
    br,
    co,
    de,
    dk,
    es,
    fr,
    gb,
    gr,
    ie,
    is,
    it,
    lu,
    mt,
    nl,
    no,
    pe,
    pt,
    se,
    us,
    uy,
    ve,
};